import 'ui-core/widgets/table-of-content/js/table-of-content';

UX.tocJs.init = function () {
    UX.tocJs.$loa = $('.issue-item .loa, .search__item .meta__authors, .search__item .loa');
    UX.tocJs.control();
};
